import { Dropdown, Button, Space } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import type { MenuProps } from 'antd';

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();

  const handleLanguageChange = (key: string) => {
    i18n.changeLanguage(key);
  };

  const menuItems: MenuProps['items'] = [
    {
      key: 'zh',
      label: t('language.chinese'),
      onClick: () => handleLanguageChange('zh'),
    },
    {
      key: 'en',
      label: t('language.english'),
      onClick: () => handleLanguageChange('en'),
    },
    {
      key: 'ja',
      label: t('language.japanese'),
      onClick: () => handleLanguageChange('ja'),
    },
  ];

  const getCurrentLanguageLabel = () => {
    switch (i18n.language) {
      case 'en':
        return t('language.english');
      case 'ja':
        return t('language.japanese');
      case 'zh':
      default:
        return t('language.chinese');
    }
  };

  return (
    <Dropdown
      menu={{ items: menuItems }}
      placement="bottomRight"
      arrow
      trigger={['click']}
    >
      <Button type="text" icon={<GlobalOutlined />}>
        <Space>
          {getCurrentLanguageLabel()}
        </Space>
      </Button>
    </Dropdown>
  );
};

export default LanguageSwitcher;